<template>    
    <BaseModal
        :id="'static'"
        :title="title"
        message="Select a building, select a Level, enter an Area name and an abbreviation. Enter the Frequency for cleaning the Area. Check the Daily, Policing, and Project shift. Click Save."
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="verify()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                />
                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'FormModal',
    props: [
        "title",
        "content_header",
        "rest_api",
        "notifications",
        "notyf",
        "axios",
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            levels:         [],
            areas:          [],
            form_data:      FormResources.form_data,
            form_format:    FormResources.form_format,
            form_backup:    {...FormResources.form_data},
        }
    },

    watch:{

        'form_data.frequency'(val)
        {
            if(val < 1 || val > 7)
            {
                this.form_data.frequency = 1
            }
        },

        async 'form_data.building_id'(val){
            if(val)
            {
                let http_request = {
                    id:             val,
                    level_request:  true,
                }
                const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`);
                if(response.status)
                {
                    if(response.data.levels.length)
                    {
                        this.array_options['level_id'] = response.data.levels
                        this.form_data.level_id = this.array_options.level_id[0].id
                    }
                    else
                    {
                        this.array_options['level_id'] = []
                        this.form_data.level_id = ''
                    }
                }
                else
                {
                    this.error_handling(response)
                }
            }
        },

    },

    methods:{

        verify() {
            let flag_verify = true;

            if(!this.form_data.daily_shift_1 && !this.form_data.daily_shift_2 && !this.form_data. daily_shift_3) {
                this.notyf.error('you must select at least one option of Daily');
                flag_verify = false;
            }
            
            if(!this.form_data.policing_shift_1 && !this.form_data.policing_shift_2 && !this.form_data.policing_shift_3) {
                this.notyf.error('you must select at least one option of Policing');
            }

            if(!this.form_data.project_shift_1 && !this.form_data.project_shift_2 && !this.form_data.project_shift_3) {
                this.notyf.error('you must select at least one option of Project');
                flag_verify = false;
            }

            if(flag_verify) {
                this.form_submit();
            } else {
                return;
            }
        }
    },

    mounted(){

    }
    
}
</script>